export default [
  { value: null, label: 'All' },
  { value: 'series', label: 'Shows' },
  { value: 'movie', label: 'Movies' }
];
